import { useState } from 'react';

export default function ToggleSwitch({ onChange }) {
  const [mode, setMode] = useState('single');

  const handleToggle = (newMode: 'single' | 'double') => {
    setMode(newMode);
    if (onChange) onChange(newMode);
  };

  return (
    <div className="toggle-container">
      <div
        className={`toggle-option ${mode === 'single' ? 'active' : ''}`}
        onClick={() => handleToggle('single')}
      >
        Single Column
      </div>
      <div
        className={`toggle-option ${mode === 'double' ? 'active' : ''}`}
        onClick={() => handleToggle('double')}
      >
        Double Columns
      </div>
      <div className={`toggle-slider ${mode === 'double' ? 'double' : ''}`} />
    </div>
  );
}
